import { IRecurrencePatternEditor } from "./RecurrencePatternEditor";

import { IDailyRecurrence, IEndsOn, IMonthlyRecurrence, IMonthlyRecurrenceOnDayX, IWeeklyRecurrence, IYearlyRecurrence, IYearlyRecurrenceOnStartDate, RecurrenceType } from "../../classes/recurrencePattern";

// State initialization methods:
export const getInitialRecurrenceType = (props: IRecurrencePatternEditor): RecurrenceType => {

	if (props.recurrencePattern) {
		return props.recurrencePattern.recurrenceType;
	} else {
		if (props.isFromTwoWayCalendar || props.isTwoWayCalendarEvent) {
			return "Daily";
		} else {
			return "Weekly";
		}
	};
};

export const getInitialDailyRecurrencePattern = (props: IRecurrencePatternEditor): IDailyRecurrence => {

	if (props.recurrencePattern && props.recurrencePattern.recurrenceType === "Daily") {
		// Return the existing Weekly recurrence pattern for the event.
		return props.recurrencePattern as IDailyRecurrence;
	} else {
		// The default daily recurrence pattern (which is only available if this is a two-way calendar) defaults to repeating every week with no end (with none of the weekdays ticked).
		const defaultCalendarRecurrencePattern: IDailyRecurrence = {
			endsOn: { endsOnType: "neverEnds" },
			recurrenceType: "Daily",
			repeatsEvery: 1,
		};
		return defaultCalendarRecurrencePattern;
	};
};

export const getInitialWeeklyRecurrencePattern = (props: IRecurrencePatternEditor): IWeeklyRecurrence => {

	if (props.recurrencePattern && props.recurrencePattern.recurrenceType === "Weekly") {
		// Return the existing Weekly recurrence pattern for the event.
		return props.recurrencePattern as IWeeklyRecurrence;
	} else {
		// The default weekly recurrence defaults to repeating every week with no end (with none of the weekdays ticked).
		const defaultCalendarRecurrencePattern: IWeeklyRecurrence = {
			endsOn: { endsOnType: "neverEnds" },
			recurrenceType: "Weekly",
			repeatsEvery: 1,
			repeatsOnWeekDays: [],
		};
		return defaultCalendarRecurrencePattern;
	};
};

export const getInitialMonthlyRecurrencePattern = (props: IRecurrencePatternEditor): IMonthlyRecurrence => {

	if (props.recurrencePattern && props.recurrencePattern.recurrenceType === "Monthly") {
		// Return the existing Weekly recurrence pattern for the event.
		return props.recurrencePattern as IMonthlyRecurrence;
	} else {
		// The default monthly recurrence defaults to repeating every week with no end (with none of the weekdays ticked).
		const defaultCalendarRecurrencePattern: IMonthlyRecurrenceOnDayX = {
			endsOn: { endsOnType: "neverEnds" },
			recurrenceSubtype: "OnDayX",
			recurrenceType: "Monthly",
			repeatsEvery: 1,
			repeatsEveryXthOfMonth: 1,
		};
		return defaultCalendarRecurrencePattern;
	};
};

export const getInitialYearlyRecurrencePattern = (props: IRecurrencePatternEditor): IYearlyRecurrence => {

	if (props.recurrencePattern && props.recurrencePattern.recurrenceType === "Yearly") {
		// Return the existing Weekly recurrence pattern for the event.
		return props.recurrencePattern as IYearlyRecurrence;
	} else {
		// The default yearly recurrence defaults to repeating every year on the same start date with no end.
		const defaultCalendarRecurrencePattern: IYearlyRecurrenceOnStartDate = {
			endsOn: { endsOnType: "neverEnds" },
			recurrenceSubtype: "OnStartDate",
			recurrenceType: "Yearly",
			repeatsEvery: 1,
		};
		return defaultCalendarRecurrencePattern;
	};
};

export const getInitialEndsOnPattern = (props: IRecurrencePatternEditor): IEndsOn => {

	if (props.recurrencePattern && props.recurrencePattern.endsOn) {
		// Return the existing Weekly recurrence pattern for the event.
		return props.recurrencePattern.endsOn as IEndsOn;
	} else {
		// The default ends on pattern defaults to 'Never Ends'.
		const defaultEndsOnPattern: IEndsOn = {
			endsOnType: "neverEnds",
		};
		return defaultEndsOnPattern;
	};
};
